import compraDireta from './CompraDiretaApiClient'
import compradorComprasDiretas from './CompradorComprasDiretasApiClient'
import fornecedorComprasDiretas from './FornecedorComprasDiretasApiClient'
import convidados from './ConvidadosApiClient'
import documentos from './DocumentosApiClient'
import documentosSolicitados from './DocumentosSolicitadosApiClient'
import importacao from './ImportacaoApiClient'
import linhasFornecimento from './LinhasFornecimentoApiClient'
import produto from './ProdutoApiClient'
import usuario from './UsuarioApiClient'
import arquivoApi from './ArquivoApi'
import CompradorIndicePrecoApiClient from './CompradorIndicePrecoApiClient'
import legado from './LegadoApiClient'

export default {
    compraDireta,
    compradorComprasDiretas,
    convidados,
    documentos,
    documentosSolicitados,
    fornecedorComprasDiretas,
    importacao,
    linhasFornecimento,
    produto,
    usuario,
    arquivoApi,
    CompradorIndicePrecoApiClient,
    legado
}
